
import { ButtonContent } from "../global/boton/ButtonContent";

function HeroSection({ bgImg, bgImg1, bgImg2, bgImg3, title, texts }) {

  const BgImages = [
    bgImg,
    bgImg1,
    bgImg2,
    bgImg3,
  ]
  return (
    <>
      <div className="pic-wrapper svgHerosection1  w-full h-screen" >
        {
          BgImages.map((item, index) => {
            return (
              <figure
                key={index}
                className={`pic-${index + 1}`}
                style={{ background: `url("${item}")` }}
              ></figure>
            )
          })
        }
        <div className="z-10 relative w-4/5 mx-auto h-full flex flex-col justify-center items-center py-10 md:py-32">
          <div className="w-full flex flex-col justify-center items-center">
            <h1 className="text-white text-center text-[35px] md:text-[60px]">
              {title}
            </h1>
            <p className="text-white text-center">
              {texts}
            </p>
          </div>

          <div className="w-full flex justify-center py-5">
            <ButtonContent btnStyle={'three'} />
          </div>
          <img src="https://firebasestorage.googleapis.com/v0/b/azteca-a-j-landscape-inc.appspot.com/o/sastifaction.png?alt=media&token=f3fa63dd-6736-40f1-9b31-244013816775" alt="Google" className="w-[350px] h-[350px] object-contain mx-auto" />

        </div>
      </div>
    </>
  );
}

export default HeroSection;
